import { Play } from 'lucide-react';

export default function VideoDemo({ onVerDemo }) {
  return (
    <section className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-extrabold text-navy-900 tracking-tight mb-12">
          Mira cómo funciona Conciliabanco en 2 minutos.
        </h2>

        <button
          onClick={onVerDemo}
          className="group relative w-full aspect-video rounded-2xl overflow-hidden bg-gradient-to-br from-navy-900 to-navy-700 shadow-2xl flex items-center justify-center"
        >
          {/* "pantalla" de fondo simulada */}
          <div className="absolute inset-0 opacity-20">
            <div className="absolute top-8 left-8 w-24 h-2.5 rounded-full bg-white" />
            <div className="absolute top-14 left-8 w-40 h-2.5 rounded-full bg-white" />
            <div className="absolute bottom-10 right-10 w-32 h-20 rounded-lg border-2 border-white" />
          </div>

          <span className="relative flex items-center justify-center w-20 h-20 rounded-full bg-white/95 shadow-xl group-hover:scale-110 transition-transform duration-300">
            <Play size={30} className="text-navy-900 ml-1" fill="currentColor" />
          </span>

          <span className="absolute bottom-5 left-1/2 -translate-x-1/2 text-white/80 text-sm font-medium">
            Ver demostración · 2:00
          </span>
        </button>
      </div>
    </section>
  );
}
